// components/AuctionComplexItem.tsx
import styled from 'styled-components';
import {
  AuctionDetailMarkerComponent,
  PlannedPropertyDetailMarkerComponent,
  PAuctionDetailMarkerComponent,
  ComplexItemComponent,
} from './marker/AuctionDetailMarker';
import { useEffect, useRef, useState } from 'react';

interface DataItemType {
  idx: number;
  img: string;
  addr: string;
  date: string;
  type: string;
  caseno: string;
  bid_prc: null | number;
  min_prc: number;
  item_code: string;
  appraisal_prc: number;
}

interface Props {
  data: any;
  scrollable: boolean;
  type: string;
  onClose: () => void;
  onToggle: (item: any) => void;
  onDragDownFromTop?: () => void;
}

const AuctionComplexItem = ({
  data,
  scrollable,
  type,
  onClose,
  onToggle,
  onDragDownFromTop,
}: Props) => {
  const startYRef = useRef<number | null>(null);
  const itemListRef = useRef<HTMLDivElement | null>(null);

  const handleTouchStart = (e: React.TouchEvent) => {
    startYRef.current = e.touches[0].clientY;
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (!scrollable || !itemListRef.current) return;

    const currentY = e.touches[0].clientY;
    const deltaY = currentY - (startYRef.current ?? currentY);

    const scrollTop = itemListRef.current.scrollTop;

    // 스크롤 최상단 + 아래로 드래그
    if (scrollTop === 0 && deltaY > 10) {
      e.preventDefault();
      onDragDownFromTop?.();
    }
  };

  if (!data || data.length === 0) return null;

  return (
    <ItemContainer>
      <ItemList
        scrollable={scrollable}
        ref={itemListRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
      >
        {data.map((item: any) => {
          switch (item.type) {
            case 'A':
              return (
                <AuctionDetailMarkerComponent
                  key={item.idx}
                  data={item}
                  onToggle={onToggle}
                />
              );
            case 'P':
              return (
                <PAuctionDetailMarkerComponent
                  key={item.idx}
                  data={item}
                  onToggle={onToggle}
                />
              );
            case 'E':
              return (
                <PlannedPropertyDetailMarkerComponent
                  key={item.idx}
                  data={item}
                  onToggle={onToggle}
                />
              );
            default:
              return (
                <ComplexItemComponent
                  key={item.idx}
                  data={item}
                  onToggle={onToggle}
                />
              );
          }
        })}
      </ItemList>
    </ItemContainer>
  );
};

export default AuctionComplexItem;

const getTypeColor = (type: string) => {
  const colors: Record<string, string> = {
    A: '#F45551',
    P: '#FF8C00',
    E: '#999999',
    R: '#28A745',
    S: '#28A745',
    D: '#28A745',
  };
  return { color: colors[type] || '#ccc' };
};

const ItemContainer = styled.div`
  width: 100%;
  height: 100%;

  background: #fff;
  overflow: hidden;
`;

const ItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px;
  border-bottom: 1px solid #ddd;
`;

const Address = styled.div`
  font-weight: bold;
  font-size: 15px;
  color: #222;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const CloseIcon = styled.img`
  width: 18px;
  height: 18px;
  cursor: pointer;
`;

const ItemList = styled.div<{ scrollable?: boolean }>`
  height: 100%;
  overflow-y: ${({ scrollable }) => (scrollable ? 'auto' : 'hidden')};
  touch-action: ${({ scrollable }) => (scrollable ? 'auto' : 'none')};
`;
